<template>
  <div>
    <div v-show="member" v-for="(l, index) in member" :key="index">
      <small class="form-text text-danger">
        {{ l }}
      </small>
      <!-- <div class="invalid-feedback" v-for="(l,index) in member" :key="index">{{l}}</div> -->
    </div>
  </div>
</template>

<script>
/** Sirve para mostrar un array de strings en mensajes pequeños y cortitos :D */

export default {
  props: {
    member: {}
  }
};
</script>

<style></style>
